import React, { ComponentType } from 'react'
import { Provider } from 'react-redux'
import store from './store'

const withProvider = <P extends Object>(WrappedComponent: ComponentType<P>) => {
  return (props: P) => (
    <Provider store={store}>
      <WrappedComponent {...props} />
    </Provider>
  )
}

export default withProvider